import { PRODUCT_TYPE } from '~/constants/ProductType';


export default function useProductType () {
  const isSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_SUBSCRIPTION || productTypeKey === PRODUCT_TYPE.MOBILE_BROADBAND_SUBSCRIPTION
  }
  const isMobileVoiceSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_SUBSCRIPTION
  }
  const isMobileBroadBandSubscription = (productTypeKey) => {
    return productTypeKey === PRODUCT_TYPE.MOBILE_BROADBAND_SUBSCRIPTION
  }
  return {
    isMobileBroadBandSubscription,
    isSubscription,
    isMobileVoiceSubscription
  }
}
